import { Routes } from '@angular/router';
import { LandingPageComponent } from '@lib/components/landing-page/landing-page.component';

import { HabilitationGuard } from './app/guards/habilitation.guard';
import { AuthGuard, InitGuard } from './app/guards/auth.guard';
import { featureTagGuard } from './app/guards/feature-tag.guard';

export const routes: Routes = [
  {
    path: 'investisseurs/from-list/:investisseurCode',
    loadChildren: () =>
      import('@lib/components/investisseur-details/investisseur-details.routes').then(mod => mod.investisseurDetailsRoutes),
    canActivate: [AuthGuard, HabilitationGuard],
  },
  {
    path: 'investisseurs/:investisseurCode',
    loadChildren: () =>
      import('@lib/components/investisseur-details/investisseur-details.routes').then(mod => mod.investisseurDetailsRoutes),
    canActivate: [AuthGuard, HabilitationGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./app/components/dashboard/dashboard.component').then(mod => mod.DashboardComponent),
    canActivate: [AuthGuard, HabilitationGuard],
  },
  {
    path: 'investisseurs',
    loadComponent: () => import('./app/components/investisseurs/investisseurs.component').then(mod => mod.InvestisseursComponent),
    canActivate: [AuthGuard, HabilitationGuard],
  },
  {
    path: 'signatures',
    loadComponent: () =>
      import('./app/components/signature/signature-consultant/signature-consultant.component').then(
        mod => mod.SignatureConsultantComponent
      ),
    canActivate: [AuthGuard, HabilitationGuard],
  },
  {
    path: 'contrats-stellium',
    loadComponent: () =>
      import('./app/components/contrats-stellium-consultant/contrats-stellium-consultant.component').then(
        mod => mod.ContratsStelliumConsultantComponent
      ),
    canActivate: [AuthGuard, HabilitationGuard],
  },
  {
    path: 'contrats-stellium/:investisseurCode/:id',
    loadComponent: () =>
      import('@lib/components/investisseur-details/tabs/contrats-stellium/contrat-stellium-detail/contrat-stellium-detail.component').then(
        mod => mod.ContratStelliumDetailComponent
      ),
    canActivate: [AuthGuard, HabilitationGuard],
  },
  {
    path: 'preferences',
    loadComponent: () =>
      import('./app/components/consultant-preferences-settings/consultant-preferences-settings.component').then(
        mod => mod.ConsultantPreferencesSettingsComponent
      ),
    canActivate: [AuthGuard, HabilitationGuard],
  },
  {
    path: 'suivi-documents',
    loadComponent: () => import('./app/components/suivi-documents/suivi-documents.component').then(mod => mod.SuiviDocumentsComponent),
    canActivate: [AuthGuard, HabilitationGuard],
  },
  {
    path: 'suivi-operations',
    loadComponent: () => import('./app/components/suivi-operations/suivi-operations.component').then(mod => mod.SuiviOperationsComponent),
    canActivate: [AuthGuard, HabilitationGuard, featureTagGuard('activateOperationFeatures')],
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('@lib/components/error-pages/unauthorized/unauthorized.component').then(mod => mod.UnauthorizedComponent),
  },
  { path: 'init', component: LandingPageComponent, canActivate: [InitGuard] },
  { path: '**', redirectTo: 'dashboard' },
];
